import React from "react";
import GateOut from "./views/GateOut";
import { GateOutContextProvider } from "./GateOutView";

const GateOutPage = () => {
  return (
    <GateOutContextProvider>
      <GateOut />
    </GateOutContextProvider>
  );
};

export default GateOutPage;
